
    <div id="mfa-container" class="container">
      <mat-card appearance="outlined">      
        <div class="center-text">
            <span class="fa-layers fa-fw icon-container ">
              <fa-icon [icon]="faCircle" class="fa-green"></fa-icon>
              <fa-icon [icon]="faShield" class="fa-white"></fa-icon>
            </span>
          <br>

          <h5 class="card-title "><strong>Multi Factor Authentication (MFA)</strong></h5>
          <span class="grey-text">Add an extra layer of security to help keep your account safe.</span>
        </div>
        <br>

        <!-- INFO BOX -->
        <div class="card mb-3 no-border">
          <div class="info-box">
            <fa-icon [icon]="faInfo" class="fa-green-icon" title="Multi Factor Authentication details"></fa-icon>
            <span><strong>   What to expect:</strong> Once enabled, you'll set it up at your next login. After setup, you'll verify your identify only about once a month when logging in.</span>
          </div>
        </div>
        <!-- INFO BOX -->

        <br>

        <!-- FORM GROUP -->
         <form [formGroup]="form" method="post">
          <!-- TOGGLE BOX -->
            <div class="authentication-info-box row">
              <div class="col-lg-7 align-left">
                <h6><strong>Multi Factor Authentication</strong></h6>
                <span class="grey-text">Protect your account with 2-step verification</span>
              </div>
              <div class="col-lg-5 align-right">
                <!-- <kendo-switch class="auth-toggle" id="priority-input" formControlName="mfa_enabled"></kendo-switch> -->
                <mat-slide-toggle class="auth-toggle" formControlName="mfa_enabled" color="primary" (change)="onToggleChange($event)"></mat-slide-toggle>
              </div>
            </div>
          <!-- TOGGLE BOX -->

          <br>

          <div *ngIf="user_mfa_setting_model?.mfa_enabled">
            <h6 class="align-left"><strong>Choose your channel to receive a code</strong></h6>

            <!-- EMAIL BOX -->
            <div class="email-info-box" [ngClass]="{'email-info-box-black': isEmailDefault, 'email-info-box': isEmailActive}">
              <div class="d-flex flex-row align-items-center flex-wrap">
                <input type="radio" class="btn-padding" (change)="onRadioClick()" formControlName="mfa_method" value="Email">
                <div class="m-1">
                  <fa-icon [icon]="faEnvelope" class="margin-left-md"> </fa-icon><strong class="margin-left-sm">Email</strong>
                </div>
              </div>
              <div class="row margin-left grey-text">
                  We'll send a code to your email address
                </div>
              <div class="row margin-left-lg">
                <div class="email-text-box col-md-5">
                  {{user_mfa_setting_model.email}}
                </div>
              </div>
            </div>
            <!-- EMAIL BOX -->

            <br>

            <!-- PHONE BOX -->
            <div class="email-info-box" [ngClass]="{'email-info-box-black': isSMSDefault, 'email-info-box': isSMSActive}">
              <div class="d-flex flex-row align-items-center flex-wrap">
                <div *ngIf="!user_mfa_setting_model?.phone?.trim()" class="d-flex flex-row align-items-center flex-wrap">
                <input type="radio" [disabled]="true" class="btn-padding" (change)="onRadioClick()">
                  <div class="m-1">
                    <fa-icon [icon]="faMobile" class="margin-left-md"> </fa-icon><strong class="margin-left-sm">Text Message (SMS)</strong>
                  </div>
                </div>

                <div *ngIf="user_mfa_setting_model?.phone?.trim()" class="d-flex flex-row align-items-center flex-wrap">
                  <input [disabled]="true" type="radio" class="btn-padding" (change)="onRadioClick()" formControlName="mfa_method" value="SMS">
                  <div class="m-1">
                    <fa-icon [icon]="faMobile" class="margin-left-md"> </fa-icon><strong class="margin-left-sm">Text Message (SMS)</strong>
                  </div>
                </div>
              </div>
              <div class="row margin-left grey-text">
                  We'll text a code to your mobile phone
                </div>
              <div class="row margin-left-lg email-text-box col-md-5">                
                <div class="col-md-9">
                  <div *ngIf="!user_mfa_setting_model?.phone?.trim()">
                    Add Mobile Phone Number            
                  </div>
                  <div *ngIf="user_mfa_setting_model?.phone?.trim()">
                    {{user_mfa_setting_model.phone | phone}}
                  </div>
                </div>
                <div class="col-md-3 align-right">
                  <button class="edit-button" (click)="open_mobile_phone_dialog('Add')" title="Add your mobile phone to receive SMS verification codes and keep your account secure.">Edit</button>
                </div>
              </div>
            </div>
            <!-- PHONE BOX -->

            <br>
            <br>

            <!-- SAVE BUTTON -->
            <button (click)="submit()" class="email-info-box col-md-12 center-text save-button" [disabled]="!form.valid">Save MFA Settings</button>
            <!-- SAVE BUTTON -->

            <br>
            <br>

            <span class="center-text grey-text">You can always change this later in your security settings.</span>
          </div>

          <br>
          
          <!-- RESULT -->
           <nexus-form-result [model]="form_result"></nexus-form-result>
          <!-- RESULT -->
         </form>
  </mat-card>
</div>